export default __webpack_public_path__ + "static/media/GettyImages-GrowthChart.d9387b00.mp4";